import React from "react";

import { Input, Select } from "clearsense-ui/components/formik";

import { ANALYSIS_TYPE_OPTIONS } from "../constants";

const AnalysisForm = () => (
  <div className="w-full py-2 space-y-4">
    <Input
      name="analysisName"
      label="Analysis Name"
      required
      placeholder="Enter a name for analysis"
    />
    <Select
      name="analysisType"
      label="Analysis Type"
      required
      options={ANALYSIS_TYPE_OPTIONS}
      placeholder="Select an analysis type"
    />
    <Input
      name="analysisTarget"
      label="Target"
      placeholder="Enter a target for analysis"
      helpText={`Format: COLUMN NAME in {"VALUE"} eg. Target in {"1"}`}
      required
    />
  </div>
);

export default AnalysisForm;
